import { render } from "./tech-specs.section.html?vue&type=template&id=b0c4a23c&scoped=true&lang=html&external"
import script from "./tech-specs.section.vue?vue&type=script&lang=js"
export * from "./tech-specs.section.vue?vue&type=script&lang=js"

import "./_tech-specs.section.mobile.scss?vue&type=style&index=0&id=b0c4a23c&lang=scss&scoped=true&external"
import "./_tech-specs.section.desktop.scss?vue&type=style&index=1&id=b0c4a23c&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c4a23c"]])

export default __exports__